// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"accent-icon_wrapper__KNnty"};